import React, { PropTypes } from 'react';
import { v4 } from 'node-uuid';
import Slider from 'react-slick';
import classnames from 'classnames';

const PrevButton = ({onClick}) => {
  return(
    <i className="fa fa-angle-left btn-prev" onClick={onClick}/>
  )
}

const NextButton = ({onClick}) => {
  return(
    <i className="fa fa-angle-right btn-next" onClick={onClick}/>
  )
}

const SETTINGS = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: <PrevButton/>,
  nextArrow: <NextButton/>
};


const How = ({ title, steps, cta_html, className, background }) => (
  <section className={classnames("block block-how", className, background)}>
    <div className="row columns show-for-medium">
      <div className="block-header">
        <h2>{title}</h2>
      </div>
    </div>
    <div className="row">
      <div className="medium-8 large-6 columns show-for-medium">
        <ol>
          {steps.map((step,i) => (
            <li key={v4()}>
              <h3>{step.title}</h3>
              <p dangerouslySetInnerHTML={{ __html: step.description_html }} />
            </li>
          ))}
        </ol>
      </div>
      <div className="small-16 medium-8 large-10 columns">
        <Slider {...SETTINGS}>
          {steps.map(step => (<div key={v4()}>
            <img src={step.image.url} alt={step.image.alt} />
            <div className="hide-for-medium text-center">
              <h3>{step.title}</h3>
              <p dangerouslySetInnerHTML={{ __html: step.description_html }} />
            </div>
          </div>))}
        </Slider>
      </div>
    </div>
    <div className="row columns text-center how-cta">
      <p dangerouslySetInnerHTML={{ __html: cta_html }} />
    </div>
  </section>
);

How.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  steps: PropTypes.array,
  cta_html: PropTypes.string,
  background: PropTypes.string,
};

export default How;



// WEBPACK FOOTER //
// ./landing_pages/components/how.jsx